// src/components/Intakes.js
import React, { useState, useEffect } from "react";
import "./Intakes.css"; // Import the CSS file
import axios from "axios";

const Intakes = () => {
  const [intakes, setIntakes] = useState([]);
  const [showAddModal, setShowAddModal] = useState(false);
  const [statusFilter, setStatusFilter] = useState("");
  const [dateFilterStart, setDateFilterStart] = useState("");
  const [dateFilterEnd, setDateFilterEnd] = useState("");

  useEffect(() => {
    // Fetch intakes from the API on component mount
    axios.get(process.env.REACT_APP_BASEURL + "/api/intake")
      .then(response => {
        console.log("here intakes",response)
        setIntakes(response.data);
      })
      .catch(error => console.error("Error fetching intakes:", error));
  }, []);

  const handleAddIntake = (intake) => {
    axios.post("/api/intakes", intake)
      .then(response => {
       
        setIntakes([...intakes, response.data]);
        setShowAddModal(false);
      })
      .catch(error => console.error("Error adding intake:", error));
  };

  const filteredIntakes = intakes.filter((intake) => {
    const matchesStatus =
      statusFilter === ""
        ? true
        : statusFilter === "present"
        ? intake.currentIntake
        : !intake.currentIntake;

    const matchesDate =
      (!dateFilterStart && !dateFilterEnd)
        ? true
        : (dateFilterStart && new Date(intake.startDate) < new Date(dateFilterStart)) ||
          (dateFilterEnd && new Date(intake.endDate) > new Date(dateFilterEnd));

    return matchesStatus && matchesDate;
  });

  return (
    <div className="intake-list">
      <h1>Intakes</h1>

      {/* Filters */}
      <div className="filters">
        <select
          onChange={(e) => setStatusFilter(e.target.value)}
          value={statusFilter}
        >
          <option value="">All Courses</option>
          <option value="present">Present Courses</option>
          <option value="other">Other Courses</option>
        </select>

        <input
          type="date"
          onChange={(e) => setDateFilterStart(e.target.value)}
          value={dateFilterStart}
          placeholder="Start Date"
        />
        <input
          type="date"
          onChange={(e) => setDateFilterEnd(e.target.value)}
          value={dateFilterEnd}
          placeholder="End Date"
        />
      </div>

      {/* Intake Cards */}
      {filteredIntakes.map((intake) => (
        <div className="intake-card" key={intake.id}>
          <h3 className="intake-title">{intake.courseName}</h3>
          <p>ID: {intake.CourseCode}</p>
          <p>Start Date: {intake.StartDate}</p>
          <p>End Date: {intake.endDate}</p>
          <p
            className={`current-intake ${
                intake.Current ? "active" : "inactive"
            }`}
          >
            Current Intake: {intake.Current ? "true" : "false"}
          </p>
        </div>
      ))}
      <button onClick={() => setShowAddModal(true)} className="btn-success">
        Add New Intake
      </button>

      {/* Add Intake Modal */}
      {showAddModal && (
        <div className="modal-overlay" onClick={() => setShowAddModal(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <span className="modal-close" onClick={() => setShowAddModal(false)}>
              &times;
            </span>
            <h2>Add New Intake</h2>
            <AddIntakeForm onSave={handleAddIntake} />
          </div>
        </div>
      )}
    </div>
  );
};

const AddIntakeForm = ({ onSave }) => {
  const [courseName, setCourseName] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [currentIntake, setCurrentIntake] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    const newIntake = { courseName, startDate, endDate, currentIntake };
    onSave(newIntake);
  };

  return (
    <form onSubmit={handleSubmit} className="add-intake-form">
      <div>
        <label>Course Name</label>
        <input
          type="text"
          value={courseName}
          onChange={(e) => setCourseName(e.target.value)}
          required
        />
      </div>
      <div>
        <label>Start Date</label>
        <input
          type="date"
          value={startDate}
          onChange={(e) => setStartDate(e.target.value)}
          required
        />
      </div>
      <div>
        <label>End Date</label>
        <input
          type="date"
          value={endDate}
          onChange={(e) => setEndDate(e.target.value)}
          required
        />
      </div>
      <div>
        <label>Current Intake</label>
        <input
          type="checkbox"
          checked={currentIntake}
          onChange={(e) => setCurrentIntake(e.target.checked)}
        />
      </div>
      <button type="submit" className="btn-primary">
        Save Intake
      </button>
    </form>
  );
};

export default Intakes;
